/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
    <div class="info-card roi-detail-card">
        <h4>Detalle del retorno de inversión</h4>
        <div class="roi-detail-table-wrapper">
            <div class="roi-detail-table">
                <div class="roi-detail-row header">
                    <span>Periodo</span>
                    <span>Consumo Hist.</span>
                    <span>Generación</span>
                    <span class="text-blue">Consumo Neto</span> <span>Nuevo Pago</span>
                    <span>Pago Hist.</span>
                    <span>Ahorro</span>
                </div>

<div class="roi-detail-row" v-for="(item, index) in roiDetail" :key="index">
    <span class="period-cell">{{ item.periodo }}</span>
    
    <span>{{ formatNumber(item.consumoHist) }} kWh</span>
    
    <span class="text-green">{{ formatNumber(item.generacion) }} kWh</span>
    
    <span class="text-blue font-bold">
        {{ formatNumber(item.consumoNeto) }} kWh
    </span>

    <span>{{ formatMoney(item.nuevoPago) }}</span>
    
    <span class="text-muted">{{ formatMoney(item.pagoHist) }}</span>
    
    <span class="text-green font-bold">{{ formatMoney(item.ahorro) }}</span>
</div>

                <div class="roi-detail-row footer">
                    <span class="col-span-6">Ahorro Total Acumulado (25 años)</span>
                    <span class="text-green text-xl">
                        {{ formatMoney(roiDetail.reduce((acc, item) => acc + item.ahorro, 0)) }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TablaRetorno',
    props: {
        roiDetail: { type: Array, required: true }
    },
    methods: {
        formatMoney(val) {
            return (val || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 });
        },
        formatNumber(val) {
            return (val || 0).toLocaleString('es-MX', { maximumFractionDigits: 0 });
        }
    }
}
</script>

<style scoped>
.info-card {
    background-color: var(--color-fondo-claro, #f8fafc);
    border-radius: 12px;
    padding: 25px;
    border: 1px solid var(--color-borde, #e2e8f0);
    margin-bottom: 25px;
}

.info-card h4 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;
    border-bottom: 1px solid #e2e8f0;
    padding-bottom: 15px;
}

.roi-detail-table-wrapper {
    overflow-x: auto;
}

.roi-detail-table {
    min-width: 1100px; 
    font-size: 13px;
    text-align: right;
}

.roi-detail-row {
    display: grid;
    grid-template-columns: 0.8fr 1fr 1fr 1fr 1fr 1fr 1fr;
    gap: 10px;
    padding: 10px 0;
    border-bottom: 1px solid #e9eef2;
    align-items: center;
}

.roi-detail-row span:first-child {
    text-align: left;
    font-weight: 600;
    color: #2d3748;
}

.roi-detail-row.header {
    font-weight: 700;
    color: #718096;
    background-color: #f1f5f9;
    padding: 12px 0;
    border-radius: 6px;
}

.roi-detail-row.footer {
    font-weight: bold;
    border-top: 2px solid #cbd5e0;
    margin-top: 15px;
    background-color: rgba(255, 255, 255, 0.5);
    padding: 15px 0;
}

.roi-detail-row.footer .col-span-6 {
    grid-column: span 6; 
    text-align: right;
    padding-right: 20px;
    font-size: 14px;
    text-transform: uppercase;
    color: #4a5568;
}

.text-green { color: #2f855a; }
.text-blue { color: #2b6cb0; } 
.text-muted { color: #a0aec0; text-decoration: line-through; font-size: 0.9em; }
.font-bold { font-weight: 700; }
.text-xl { font-size: 1.2em; color: #2f855a; }

.period-cell {
    padding-left: 10px;
}
</style>